import { render, staticRenderFns } from "./send_contract.vue?vue&type=template&id=0a3f6cf6&scoped=true"
import script from "./send_contract.vue?vue&type=script&lang=js"
export * from "./send_contract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3f6cf6",
  null
  
)

export default component.exports